import { Roles } from "../../../mp-utils/generic-utils"
// import DistrictSearch from "./Filters/DistrictSearch"
// import SchoolSearch from "./Filters/SchoolSearch"
// import ClassSearch from "./Filters/ClassSearch"
// import TeacherSearch from "./Filters/TeacherSearch"
// import StudentSearch from "./Filters/StudentSearch"

export const FILTER_TYPES = {
  district: {
    label: "District",
    l_label: "district",
    studentSearchKey: "schoolDistrict",
    collection: "districts",
    // component: DistrictSearch,
    placeholder: "Select District"
  },
  school: {
    label: "School",
    l_label: "school",
    studentSearchKey: "school",
    // component: SchoolSearch,
    collection: "schools",
    placeholder: "Select School"
  },
  teacher: {
    label: "Teacher",
    l_label: "teacher",
    studentSearchKey: "teachers",
    // component: TeacherSearch,
    collection: "educators",
    placeholder: "Select Teacher"
  },
  class: {
    label: "Class",
    l_label: "class",
    studentSearchKey: "classes",
    // component: ClassSearch,
    collection: "classes",
    placeholder: "Select Class"
  },
  student: {
    label: "Student",
    l_label: "s",
    studentSearchKey: "student",
    // component: StudentSearch,
    collection: "students",
    placeholder: "Select Student"
  }
}

// Super Administrator filters
const SUPER_ADMINISTRATOR = [
  FILTER_TYPES.district,
  FILTER_TYPES.school,
  FILTER_TYPES.teacher,
  FILTER_TYPES.class,
  FILTER_TYPES.student
]

// District Admin filters
const DISTRICT_ADMIN = [
  FILTER_TYPES.school,
  FILTER_TYPES.teacher,
  FILTER_TYPES.class,
  FILTER_TYPES.student
]

// School Admin filters
const SCHOOL_ADMIN = [
  FILTER_TYPES.teacher,
  FILTER_TYPES.class,
  FILTER_TYPES.student
]

// Course Author filters
const COURSE_AUTHOR = [
  FILTER_TYPES.district,
  FILTER_TYPES.school,
  FILTER_TYPES.teacher,
  FILTER_TYPES.class,
  FILTER_TYPES.student
]

// Course Author filters
const SALES_REP = [
  FILTER_TYPES.district,
  FILTER_TYPES.school,
  FILTER_TYPES.teacher,
  FILTER_TYPES.class
]

// Instructor role filters
const INSTRUCTOR = [
  FILTER_TYPES.district,
  FILTER_TYPES.school,
  FILTER_TYPES.class,
  FILTER_TYPES.student
]

// Teacher filters
const TEACHER = [FILTER_TYPES.school, FILTER_TYPES.class, FILTER_TYPES.student]

// Student
const STUDENT: [] = []

// Final filters ready to export
const FILTERS = {
  [Roles.Super_Administrator]: SUPER_ADMINISTRATOR,
  [Roles.District_Admin]: DISTRICT_ADMIN,
  [Roles.School_Admin]: SCHOOL_ADMIN,
  [Roles.Course_Author]: COURSE_AUTHOR,
  [Roles.Sales_Rep]: SALES_REP,
  [Roles.Instructor]: INSTRUCTOR,
  [Roles.Teacher]: TEACHER,
  [Roles.Student]: STUDENT
}

export const getFiltersByRole = (role: string) => {
  return FILTERS[role]
}

export const rolesToConsiderForTeachersFilter = {
  [Roles.Super_Administrator]: [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  [Roles.District_Admin]: [
    Roles.District_Admin,
    Roles.School_Admin,
    Roles.Teacher
  ],
  [Roles.School_Admin]: [Roles.School_Admin, Roles.Teacher],
  [Roles.Teacher]: [Roles.Teacher]
}

export default FILTERS
